import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../layouts/MainLayout';
import { Card, Form, Input, Select, Button, Divider, message } from 'antd';
import { SaveOutlined, CloseOutlined, PlusOutlined, ApartmentOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { designationsApi } from '../../../utils/api';
import { scrollToFirstError } from '../../../utils/formHelpers';

const { Option } = Select;

const AddPosition = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    loadParents();
  }, []);

  const loadParents = async () => {
    setLoading(true);
    try {
      const res = await designationsApi.getAll();
      setPositions(res.data || []);
    } catch (e) {
      console.error(e);
      message.error('خطا در دریافت لیست سمت‌ها');
    }
    setLoading(false);
  };

  const onFinish = async (values) => {
    try {
      const validatedValues = await form.validateFields();
      setLoading(true);
      const payload = {
        name: validatedValues.name,
        parent_id: validatedValues.parent_id || null,
      };
      await designationsApi.create(payload);
      message.success('سمت با موفقیت ایجاد شد');
      navigate('/hr/positions');
    } catch (e) {
      if (e.errorFields && e.errorFields.length > 0) {
        scrollToFirstError(form);
      } else {
        console.error(e);
        message.error(e?.message || 'خطا در ایجاد سمت');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="" style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between gap-4 p-6 border-b border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 text-white flex items-center justify-center shadow-lg">
                <PlusOutlined className="text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">افزودن سمت شغلی</h1>
                {/* <p className="text-gray-500 dark:text-gray-400 text-sm m-0">ایجاد سمت جدید و تعیین والد (اختیاری)</p> */}
              </div>
            </div>
            <Button
              icon={<ArrowRightOutlined />}
              onClick={() => navigate('/hr/positions')}
              className="flex items-center gap-2"
              style={{ fontFamily: 'CustomFont' }}
            >
              بازگشت
            </Button>
          </div>

          <div className="p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            <Card className="border border-gray-100 dark:border-gray-700 shadow-sm bg-white dark:bg-gray-800">
              <Form form={form} layout="vertical" onFinish={onFinish} scrollToFirstError={{ behavior: 'smooth', block: 'center' }} style={{ fontFamily: 'CustomFont' }} size="middle">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Form.Item
                    label="نام سمت"
                    name="name"
                    rules={[
                      { required: true, message: 'نام سمت را وارد کنید' },
                      { min: 2, message: 'حداقل 2 کاراکتر' },
                      { max: 100, message: 'حداکثر 100 کاراکتر' },
                    ]}
                  >
                    <Input placeholder="مثال: مدیر فروش" prefix={<ApartmentOutlined className="text-gray-400" />} />
                  </Form.Item>

                  <Form.Item label="سمت والد" name="parent_id">
                    <Select
                      placeholder="انتخاب سمت والد (اختیاری)"
                      allowClear
                      showSearch
                      loading={loading}
                      filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
                    >
                      {positions.map((p) => (
                        <Option key={p.id} value={p.id}>
                          {p.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>

                <Divider />

                <div className="flex items-center justify-end gap-3">
                  <Button icon={<CloseOutlined />} onClick={() => navigate('/hr/positions')} style={{ minWidth: '110px' }}>
                    لغو
                  </Button>
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    htmlType="submit"
                    loading={loading}
                    className="bg-emerald-600 hover:bg-emerald-700 border-0"
                    style={{ minWidth: '140px' }}
                  >
                    ذخیره سمت
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default AddPosition;

